import {
  CheckSquareOutlined,
  DownOutlined,
  LaptopOutlined,
  PieChartOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import useProfileData from "../../hooks/useProfileData";
import { useEffect, useState } from "react";
import { fetchWrapper } from "../../utils/misc";

export default function OtherUserNavbar() {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userId = userData.loginId;
  const [probationInfo, setProbationInfo] = useState({
    isOnProbation: null,
    probationStatus: null,
  });
  const { profileData } = useProfileData();
  const onClick = ({ key }) => {
    // message.info(`Click on item ${key}`);
    navigate(`/${key}`, { replace: true });
  };
  const navigate = useNavigate();

  const attendance = [
    {
      label: "Mark Attendance",
      key: "Attendance/MarkAttendance",
    },
    {
      label: "Attendance Report",
      key: "Attendance/AttendanceList",
    },
    {
      label: "Request Leave",
      key: "Attendance/RequestLeave",
    },
    {
      label: "Leave History",
      key: "Attendance/LeaveHistory",
    },
    {
      label: "Subordinates Leave History",
      key: "LeaveDetail/SubordinateLeaveHistory",
    },
    // {
    //     label: 'Attendance Report',
    //     key: 'Attendance/AttendanceReport'
    // },
    // {
    //     label: 'Absent Report',
    //     key: 'Attendance/AbsentReport'
    // }
  ];
  const training = [
    {
      label: "Training Feedback",
      key: "Training/Feedback",
    },
    {
      label: "Suggesstions",
      key: "Training/Suggestions",
    },
    {
      label: "Training Details",
      key: "Training/Details",
    },
  ];

  const performance = [
    {
      label: "My Review Form",
      key: "Appraisal/MEAppraisalForm",
    },
    {
      label: "Manager Audit",
      key: "Appraisal/ManagerAuditEmpList",
    },
  ];
  const userProjectItems = [
    {
      label: "Assinged Projects",
      key: "Projects/AssignedProject",
    },
    {
      label: "Activity Status",
      key: "Projects/ActivityStatus",
    },
  ];

  const Kras = [
    {
      label: "My KRA",
      key: "MyKRAForm",
    },
    {
      label: "Approve KRA",
      key: "ManagerKRAapproval",
    },
  ];

  const info = [
    {
      label: "Subordinate Resignation List",
      key: "ResignationInfo/ReportingHeadList",
      isVisible: userData.isReportingHead,
    },
    {
      label: "Resignation Status",
      key: "ResignationInfo/ResignationStatus",
      isVisible: userData.isResigned,
    },
  ].filter((item) => item.isVisible);

  const reimbursement = [
    {
      label: "Reimbursement",
      key: "Reimbursement",
    },
    {
      label: "List",
      key: "Reimbursement/List",
    },
  ];

 
  const reviewFormLink = profileData.appraisalFormId
    ? profileData.appraisalFormId === 1
      ? `Appraisal/1?EmpId=${profileData.loginId}`
      : profileData.appraisalFormId === 2
        ? `Appraisal/2?EmpId=${profileData.loginId}`
        : profileData.appraisalFormId === 3
          ? `Appraisal/3?EmpId=${profileData.loginId}`
          : profileData.appraisalFormId === 5
            ? `Appraisal/5?EmpId=${profileData.loginId}`
            : "Appraisal/Not-Found"
    : "Appraisal/Not-Found";

  const reviewAndPerformace = [
    {
      label: "My Review Form",
      key: reviewFormLink,
    },
    {
      label: "Manager Audit",
      key: "Appraisal/ManagerAuditEmpList",
    },
  ];

  useEffect(() => {
    const fetchProbationInfo = async () => {
      try {
        const reqUrl = `${localStorage.getItem("BaseUrl")}/Confirmation/ViewStepInfo?EmpId=${userData.loginId}`;
        const result = await fetchWrapper("GET", reqUrl, null, false);
        if (result.resCode >= 200 && result.resCode < 300) {
          const obj = {
            isOnProbation: result.resData.isOnProbition,
            probationStatus: result.resData.probitionStatus,
          };

          const keyExists = Boolean(localStorage.getItem("probationInfo"));
          if (!keyExists) {
            localStorage.setItem("probationInfo", JSON.stringify(obj));
          }
          setProbationInfo(obj);
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchProbationInfo();
  }, []);

  return (
    <div className="dropdown-navbar">
      {/* attendance */}
      <Dropdown
        menu={{
          items: attendance,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <ToolOutlined />
            Attendance Details
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
      {userData?.loginId !== 6 &&
        userData.userRole === "Power" && ( // TODO: add the psg vertical condition also
          <Dropdown
            menu={{
              items: userProjectItems,
              onClick,
            }}
          >
            <a
              onClick={(e) => e.preventDefault()}
              style={{
                color: "black",
                fontSize: "13px",
                fontWeight: 600,
                marginLeft: "0.75rem",
              }}
            >
              <Space>
                <ToolOutlined />
                Project Activity
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        )}

      {(userData?.loginId === 163 ||
        userData?.loginId === 9999 ||
        // userData?.loginId === 1195 ||
        // userData?.loginId === 1050 ||
        // userData?.loginId === 1134 ||
        userData?.loginId === 1181 ||
        userData?.userRole === "Network") && (
          //   (userData?.vertical)// TODO: add the psg vertical condition also
          <Link
            to="/ITEquipment"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <LaptopOutlined />
              IT Equipment Inventory
            </Space>
          </Link>
        )}
      {/* <Dropdown
        menu={{
          items: training,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <ToolOutlined />
            Training
            <DownOutlined />
          </Space>
        </a>
      </Dropdown> */}

      <Dropdown
        className="mx-2"
        menu={{
          items: Kras,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <PieChartOutlined />
            KRA
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

    
      <Dropdown
        menu={{
          items: reviewAndPerformace,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <ToolOutlined />
            Review
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      {/* <Link
        to="/WeeklyReport"
        style={{
          color: "black",
          fontSize: "13px",
          fontWeight: 600,
          marginLeft: "0.75rem",
        }}
      >
        <Space>
          <TbReport />
          Weekly Report
        </Space>
      </Link> */}

      {/* <Dropdown
        menu={{
          items: reimbursement,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <ToolOutlined />
            Reimbursement
            <DownOutlined />
          </Space>
        </a>
      </Dropdown> */}

      {probationInfo &&
        probationInfo?.isOnProbation &&
        !userData.isResigned && (
          <Link
            to="/Confirmation/CheckProbation"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <CheckSquareOutlined />
              Probation
            </Space>
          </Link>
        )}

      {userData.isReportingHead && (
        <Link
          to="/ResignationInfo/ReportingHeadList"
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
          }}
        >
          <Space>
            <CheckSquareOutlined />
            Resignation List
          </Space>
        </Link>
      )}

      {
        (userData.reportingHeadId === 1272 && userData.isAppEng) && (
          <Link
            to="/Forecast"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <ToolOutlined />
              Forecast
            </Space>
          </Link>
        )
      }

      {info.length > 0 && (
        <Dropdown
          menu={{
            items: info,
            onClick,
          }}
        >
          <a
            onClick={(e) => e.preventDefault()}
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <ToolOutlined />
              Info
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      )}
    </div>
  );
}
